import { type ReactNode } from 'react';
import { Input } from '@/components/ui/input';
import type { Tier } from '../hooks/use-pricing-table';
import { PricingTierEditor } from './pricing-tier-editor';

// 19b implicit-max model: only range_min is editable. The "max" of a range
// is derived per-read from the next vigente row's range_min.
export type RangeFormState = {
  rangeMin: string;
  rangeLabel: string;
  tiers: Tier[];
};

type Props = {
  state: RangeFormState;
  setState: (s: RangeFormState) => void;
  disableBounds: boolean;
};

function patch(
  state: RangeFormState,
  p: Partial<RangeFormState>
): RangeFormState {
  return { ...state, ...p };
}

export function RangeFormFields(p: Props): ReactNode {
  const { state, setState, disableBounds } = p;
  return (
    <div className="space-y-md">
      <Input
        label="Min creators"
        type="number"
        value={state.rangeMin}
        onChange={(e) => setState(patch(state, { rangeMin: e.target.value }))}
        disabled={disableBounds}
      />
      <Input
        label="Etiqueta"
        value={state.rangeLabel}
        onChange={(e) => setState(patch(state, { rangeLabel: e.target.value }))}
        placeholder="Default"
      />
      <PricingTierEditor
        tiers={state.tiers}
        onChange={(tiers) => setState(patch(state, { tiers }))}
      />
    </div>
  );
}
